module.exports = new __parcel__URL__("globe_k12_learning.08bafd1b.png").toString();